var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h1", [_vm._v(_vm._s(_vm.$t("register.finished.header")))]),
    _vm._v(" "),
    _c("div", { staticClass: "ct-card" }, [
      _c("section", { staticClass: "top-margin" }, [
        _vm.showMessage
          ? _c(
              "div",
              {
                staticClass: "ct-text alert alert-dismissible",
                class: {
                  "alert-success": _vm.messageType === "success",
                  "alert-danger": _vm.messageType === "error"
                },
                attrs: { role: "alert" }
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.hideAlert()
                      }
                    }
                  },
                  [
                    _c("span", { attrs: { "aria-hidden": "true" } }, [
                      _vm._v("×")
                    ])
                  ]
                ),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t(_vm.messageKey)) +
                    "\n            "
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.information.isDuplicate
          ? _c("div", {
              staticClass: "ct-text",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("register.finished.duplicate", {
                    email: _vm.email,
                    churchName: _vm.churchName
                  })
                )
              }
            })
          : _vm._e(),
        _vm._v(" "),
        !_vm.information.isDuplicate && !_vm.forDenomination
          ? _c("div", {
              staticClass: "ct-text",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("register.finished.description", { email: _vm.email })
                )
              }
            })
          : _vm._e(),
        _vm._v(" "),
        !_vm.information.isDuplicate && _vm.forDenomination
          ? _c("div", {
              staticClass: "ct-text",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("register.finished.descriptionDenomination", {
                    email: _vm.email,
                    denominationEmail: _vm.denominationEmail,
                    denominationName: _vm.denominationName
                  })
                )
              }
            })
          : _vm._e()
      ]),
      _vm._v(" "),
      !_vm.forDenomination
        ? _c("section", { staticClass: "ct-action ct-border" }, [
            _c("div", { staticClass: "ct-row two-elements" }, [
              !_vm.information.isDuplicate
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      on: {
                        click: function($event) {
                          return _vm.resendEmail()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("register.finished.resend")) +
                          "\n                "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.information.isDuplicate
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      on: {
                        click: function($event) {
                          return _vm.toggleEmailInput()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("register.finished.editEmail")) +
                          "\n                "
                      )
                    ]
                  )
                : _vm._e()
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.forDenomination
        ? _c("section", { staticClass: "ct-action ct-border" }, [
            _c("div", { staticClass: "ct-row two-elements" }, [
              _c("a", { attrs: { href: _vm.statusUrl } }, [
                _c("button", { staticClass: "btn btn-primary" }, [
                  _vm._v(_vm._s(_vm.$t("register.finished.status")))
                ])
              ]),
              _vm._v(" "),
              _c("a", { attrs: { href: _vm.againUrl } }, [
                _c("button", { staticClass: "btn btn-primary" }, [
                  _vm._v(_vm._s(_vm.$t("register.finished.again")))
                ])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showEmailInput && !_vm.forDenomination
        ? _c("section", { staticClass: "ct-border ct-change-email" }, [
            _c(
              "div",
              [
                _c("text-input", {
                  attrs: {
                    config: {
                      translationKey: "label.email",
                      required: true,
                      id: "email"
                    },
                    "input-model": _vm.register.email,
                    error: _vm.getError("email")
                  },
                  on: {
                    "update:inputModel": function($event) {
                      return _vm.$set(_vm.register, "email", $event)
                    },
                    "update:input-model": function($event) {
                      return _vm.$set(_vm.register, "email", $event)
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "ct-input-element ct-align-center" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-lg",
                      attrs: { type: "button" },
                      on: { click: _vm.changeEmail }
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("register.finished.saveEmail")) +
                          "\n                    "
                      )
                    ]
                  )
                ])
              ],
              1
            )
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5665be64", { render: render, staticRenderFns: staticRenderFns })
  }
}